/** @file Viridis colour ramp (colourblind-safe) sampled at nine stops and interpolated linearly. */
import { color } from '@pose2d/math/color';

/** Matplotlib's viridis (CC0) at t = 0, 1/8, ..., 1 as [r, g, b]. */
const STOPS: [number, number, number][] = [
  [0x44, 0x01, 0x54], [0x47, 0x2d, 0x7b], [0x3b, 0x52, 0x8b], [0x2c, 0x72, 0x8e], [0x21, 0x91, 0x8c],
  [0x28, 0xae, 0x80], [0x5e, 0xc9, 0x62], [0xad, 0xdc, 0x30], [0xfd, 0xe7, 0x25],
];

/** Packed colour of the ramp at t (clamped to 0..1; NaN reads as 0) with the given alpha byte. */
export function viridis(t: number, alpha: number): number {
  const x = (Number.isFinite(t) ? Math.min(1, Math.max(0, t)) : 0) * (STOPS.length - 1);
  const i = Math.min(STOPS.length - 2, Math.floor(x)), f = x - i;
  const a = STOPS[i] ?? [0, 0, 0], b = STOPS[i + 1] ?? [0, 0, 0];
  const mix = (k: 0 | 1 | 2): number => Math.round(a[k] + (b[k] - a[k]) * f);
  return color.pack(mix(0), mix(1), mix(2), alpha);
}
